import { Component } from "react"

import AttendeeSelectionView from "components/church_center/attendee_selection/attendee_selection_view"
import moment from "moment-timezone"
import PropTypes from "prop-types"

class AttendeeSelectionContainer extends Component {
  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleAttendeeSelectionChange = this.handleAttendeeSelectionChange.bind(this)
    this.handleNewAttendeeChange = this.handleNewAttendeeChange.bind(this)
    this.handleNewAttendee = this.handleNewAttendee.bind(this)
    this.generateNewAttendee = this.generateNewAttendee.bind(this)
    this.displayAlreadyRegistered = this.displayAlreadyRegistered.bind(this)

    this.state = {
      attendees: [],
      attendeeSelections: props.attendeeSelections,
      newAttendees: [],
      newAttendeesList: [],
      loading: false,
      addMoreThenOneAttendee: false,
      zValue: 8500,
      nextButtonClicked: false,
      disabledSubmit: false
    }
  }

  componentDidMount() {
    this.displayAlreadyRegistered()
  }

  render() {
    return (
      <AttendeeSelectionView
        {...this.props}
        {...this.state}
        onSubmit={this.handleSubmit}
        onClick={this.handleClick}
        onAttendeeSelectionChange={this.handleAttendeeSelectionChange}
        onNewAttendee={this.handleNewAttendee}
        loginUrl={this.props.loginUrl}
        gradeOptions={this.props.gradeOptions}
        genderOptions={this.props.genderOptions}
        guest={this.props.guest}
        eventStartDate={this.props.eventStartDate}
        onNewAttendeeChange={this.handleNewAttendeeChange}
      />
    )
  }

  handleClick(newState) {
    this.setState(Object.assign(newState, { loading: true }), this.handleSubmit)
  }

  handleAttendeeSelectionChange(attendeeState) {
    const { attendees } = this.state
    const attendee = attendees.find(attendee => attendee.personId === attendeeState.personId)

    if (!attendeeState.checked) {
      this.setState({
        attendees: attendees.filter(attendee => attendee.personId !== attendeeState.personId)
      })
    } else {
      if (attendee) {
        this.setState({
          attendees: attendees.map(attendee => {
            if (attendee.personId === attendeeState.personId) {
              return { ...attendee, ...attendeeState }
            } else {
              return attendee
            }
          })
        })
      } else {
        this.setState({
          attendees: [...attendees, attendeeState]
        })
      }
    }
  }

  handleNewAttendeeChange(attendeeState) {
    const { newAttendees } = this.state
    const attendee = newAttendees.find(a => a.key === attendeeState.key)
    if (!attendeeState.checked) {
      newAttendees.splice(newAttendees.indexOf(attendee), 1)
      this.setState({ newAttendees })
    } else {
      if (attendee) {
        Object.assign(attendee, attendeeState)
      } else {
        newAttendees.push({ ...attendeeState })
      }
      this.setState({ newAttendees })
    }
  }

  handleSubmit() {
    this.setState({ nextButtonClicked: true, disabledSubmit: true })
    const attendees_attributes = this.state.attendees.map(a => {
      return {
        person_id: a.personId,
        gender: a.gender,
        birthdate: this.formatBirthdate(a.birthdate),
        grade: a.grade,
        attendee_type_id: a.attendeeTypeId
      }
    })

    const new_attendees_attributes = this.state.newAttendees.map(a => {
      return {
        first_name: a.firstName,
        last_name: a.lastName,
        gender: a.gender,
        birthdate: this.formatBirthdate(a.birthdate),
        grade: a.grade,
        email_address: a.emailAddress,
        attendee_type_id: a.attendeeTypeId,
        household: {
          add: a.householdAdd ? "yes" : "no",
          household_to_join: a.householdId
        }
      }
    })

    let bodyBlob = {
      registration: {
        attendees_attributes,
        new_attendees_attributes
      }
    }

    if (window.location.href.match(/source=([^&]+)/)) {
      bodyBlob["source"] = RegExp.$1
    }

    fetch(this.props.eventRegistrationsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken()
      },
      credentials: "include",
      body: new Blob([JSON.stringify(bodyBlob)], {}, 2)
    })
      .then(resp => resp.json())
      .then(resp => {
        if (resp.errors) {
          console.error(resp.errors)
          alert(resp.errors)
        } else {
          Turbolinks.visit(resp.url)
        }
      })
  }

  handleNewAttendee() {
    const { newAttendeesList } = this.state
    this.setState(prevState => {
      return { zValue: prevState.zValue - 1 }
    })
    newAttendeesList.push(this.generateNewAttendee())
    this.setState({ newAttendeesList })
    this.setState({ addMoreThenOneAttendee: true })
  }

  generateNewAttendee() {
    const { addMoreThenOneAttendee, zValue } = this.state
    const key = Math.random() * 8

    return { zValue, addMoreThenOneAttendee, key }
  }

  displayAlreadyRegistered() {
    if (this.props.registeredForEvent && this.state.currentView === AttendeeSelectionView) {
      alertModal(
        {
          title: "You have already registered",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Register again",
          confirmButtonText: "View registration",
          customClass: "warning",
          closeOnConfirm: true
        },
        () => {
          Turbolinks.visit(this.props.currentRegistrationUrl)
        }
      )
    }
    return null
  }

  formatBirthdate(date) {
    if (date === undefined || !date || date.length < 1) {
      return ""
    }
    let formatted = moment(date, App.currentOrganization.momentDateFormat).format("YYYY-MM-DD")
    if (formatted === "Invalid date") {
      formatted = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD")
    }
    return formatted === "Invalid date" ? null : formatted
  }
}

AttendeeSelectionContainer.propTypes = {
  currentRegistrationUrl: PropTypes.string,
  eventRegistrationsUrl: PropTypes.string.isRequired,
  guest: PropTypes.bool,
  registeredForEvent: PropTypes.bool
}

AttendeeSelectionContainer.defaultProps = {
  currentRegistrationUrl: "",
  registeredForEvent: false
}

export default AttendeeSelectionContainer
